import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SYSTEM_VIEW_CLASS_NAME = 'SystemView';

export const SYSTEM_VIEW_CLASS_SLOTS = [
	'root',
	'controls',
	'content',
	'extras',
	'filters',
	'header',
	'title',
] as const;

export type SystemViewClassSlot = (typeof SYSTEM_VIEW_CLASS_SLOTS)[number];

export interface SystemViewClasses {
	root: string;
	controls: string;
	content: string;
	extras: string;
	filters: string;
	header: string;
	title: string;
}

export type SystemViewClassKey = keyof SystemViewClasses;

export const getSystemViewUtilityClass = (slot: string) =>
	generateUtilityClass(SYSTEM_VIEW_CLASS_NAME, slot);

export const systemViewClasses = generateUtilityClasses<
	keyof SystemViewClasses
>(SYSTEM_VIEW_CLASS_NAME, [
	'root',
	'content',
	'controls',
	'extras',
	'filters',
	'header',
	'title',
]);

export default systemViewClasses;
